import React from 'react';
import Field from '../fields/Field';
import { getTranslation } from '../../lang/main';
import StripeCreditCardFormFields from './StripeCreditCardFormFields';
import LocalizedMessage from 'react-l10n';
import FieldCheckbox from '../fields/FieldCheckbox';
import AddressFormFields from '../common/AddressFormFields';
import { printAddressNicely } from '../../selectors/addressSelector';
import { injectStripe } from 'react-stripe-elements';
import {getFieldStatusProps} from "../../selectors/defaultSelectors";
import FieldSelect from "../PaymentMethodForm/PaymentMethodFormCreditCardTab";

const FORM_LABEL = {
    CardName: getTranslation('FIELD.NAME_ON_CARD'),
    Number: getTranslation('FIELD.CARD_NUMBER'),
    ExpiryMonthYear: getTranslation('FIELD.EXPIRY_MONTH_YEAR'),
    Cvv: getTranslation('FIELD.CVV'),
};

function NewCreditCardFormFields(props) {
    const {
        fieldRefs,
        fieldStatus,
        formData,
        updateFormData,
        handleFormUpdate,
        handleFormUpdateNumber,
        setIsCreditCardValidated,
        currentBillingAddress,
        required,
    } = props;
    const showCreditCardBillingAddressFields =
        typeof props.showCreditCardBillingAddressFields != 'undefined'
            ? props.showCreditCardBillingAddressFields
            : true;
    const niceBillingAddress = printAddressNicely(currentBillingAddress);

    return (
        <React.Fragment>
            <Field
                ref={(r) => (fieldRefs.CardName = r)}
                required={required}
                label={FORM_LABEL['CardName']}
                animatedLabel={FORM_LABEL['CardName']}
                name='CardName'
                value={formData.CardName}
                onChange={handleFormUpdate}
                {...getFieldStatusProps(fieldStatus, 'CardName')}
            />
            <StripeCreditCardFormFields
                required={required}
                setIsCreditCardValidated={setIsCreditCardValidated}
            />

            {showCreditCardBillingAddressFields === true && (
                <React.Fragment>
                    <div className='vspace vspace--small'>
                        <span className='heading heading--lv5'>
                            <LocalizedMessage
                                id={'CREDIT_CARD_FORM.CURRENT_BILLING_ADDRESS'}
                            />
                        </span>
                        <div className='text-box text-box--small text-box--grey'>
                            {niceBillingAddress != '' ? (
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: niceBillingAddress,
                                    }}
                                />
                            ) : (
                                <p>
                                    <LocalizedMessage
                                        id={
                                            'CREDIT_CARD_FORM.NO_CURRENT_BILLING_ADDRESS'
                                        }
                                    />
                                </p>
                            )}
                        </div>
                    </div>

                    <FieldCheckbox
                        ref={(r) => (fieldRefs.UseNewBillingAddress = r)}
                        checked={formData.UseNewBillingAddress == 1}
                        label='Use New Address'
                        name='UseNewBillingAddress'
                        value={formData.UseNewBillingAddress == 1 ? 0 : 1}
                        onChange={handleFormUpdateNumber}
                    />

                    {formData.UseNewBillingAddress == 1 && (
                        <div
                            className={`collapse ${
                                formData.UseNewBillingAddress == 1 ? 'in' : ''
                            }`}
                        >
                            <AddressFormFields
                                defaultIsRequired={
                                    formData.UseNewBillingAddress == 1
                                }
                                fieldRefs={fieldRefs}
                                formData={formData}
                                updateField={updateFormData}
                                onFieldUpdate={handleFormUpdate}
                            />
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

class InjectedNewCreditCardFormFields extends React.Component {
    render() {
        return <NewCreditCardFormFields {...this.props} />;
    }
}

export default injectStripe(InjectedNewCreditCardFormFields);
